import axios from "axios";

export class API {

  urlPrefix = "?adleads_api=1&endpoint=";

  _get(url, options) {
    return axios.get(url, options).catch((error) => {
      return Promise.reject(error);
    });
  }

  _post(endpoint, data, options) {
    return new Promise((resolve, reject) => {
      axios.post(this.urlPrefix + endpoint, data, options).then(response => {
        if (response.data) {
          let doc = new DOMParser().parseFromString(response.data, "text/html");
          doc.innerHTML = response.data;
          let str = doc.getElementById('anslagstavlan_api').innerText;
          str = doc.getElementById('anslagstavlan_api').innerHTML;
          response.data = JSON.parse(str.replaceAll("”", '"').replaceAll("″", '"'));
          if (response.data.success == false) {
            reject(response);
          } else {
            resolve(response);
          }
        } else {
          reject(response);
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.error) {
          reject(error.response.data.error.exception[0].message);
        }
        reject(error);
      });
    });
  }

  auth_login(username, password) {
    return this._post("api/login", {
      username, password
    }).then((response) => {
      return response;
    });
  }

  auth_create(values) {
    return this._post("api/create", {
      values
    }).then((response) => {
      return response;
    });
  }

  get_user_info(username) {
    return this._post("api/user", {
      username
    }).then((response) => {
      return response;
    });
  }

  user_update(values) {
    return this._post("api/user-update", {values}).then(response => {
      return response;
    });
  }

  user_reset_password(email) {
    return this._post("api/user-reset-password", {email}).then(response => {
      return response;
    });
  }

  user_reset_password_confirm(username, hash, password) {
    return this._post("api/user-reset-password-confirm", {username, hash, password}).then(response => {
      return response;
    });
  }

  get_competences() {
    return this._post("api/get-competences", {}).then((response) => {
      return response;
    });
  }

  add_competence(name) {
    return this._post("api/add-competence", {name}).then((response) => {
      return response;
    });
  }

  add_assignment(assignment) {
    return this._post("api/add-assignment", {assignment}).then((response) => {
      return response;
    });
  }

  delete_assignment(id) {
    return this._post("api/delete-assignment", {id}).then((response) => {
      return response;
    });
  }

  get_assignments() {
    return this._post("api/get-assignments", {}).then((response) => {
      return response;
    });
  }

  send_empty_assignment_reply(username, assignmentId, text) {
    return this._post("api/send-empty-assignment-reply", {username, assignmentId, text}).then((response) => {
      return response;
    });
  }

  send_assignment_reply(assignmentId, text) {
    return this._post("api/send-assignment-reply", {assignmentId, text}).then((response) => {
      return response;
    });
  }

  admin_search(values) {
    return this._post("api/admin-search", {values}).then((response) => {
      return response;
    });
  }

  admin_set_competences(competences) {
    return this._post("api/admin-set-competences", {competences}).then((response) => {
      return response;
    });
  }

  /**
   * @returns API
   */
  static getAPI() {
    return new API();
  }
}
